import React from "react";
import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

const Parallax = ({ type }) => {
  const ref = useRef();
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end center"],
  });
  const yBg = useTransform(scrollYProgress, [0, 1], ["0%", "50%"]);
  const yText = useTransform(scrollYProgress, [0, 1], ["0%", "500%"]);
  const yBgslow = useTransform(scrollYProgress, [0, 1], ["0%", "10%"]);
  
  return (
    <div
      className="d-flex justify-content-center align-items-center"
      id="parallax"
      ref={ref}
      style={{
        background:
          type === "services"
            ? "linear-gradient(180deg, #111132, #0c0c1d)"
            : "linear-gradient(180deg, #111132, #505064)",
      }}
    >
      <motion.h1
  className=""
  style={{
    y: yText, // This likely controls the vertical position of the text
    color: 'yellow', // Sets the text color to yellow
    fontSize: '10vw', // Sets the font size to 100 pixels
    filter: 'drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.4))',
    fontFamily: "Roboto, sans-serif"
  }}
>
  {type === "services" ? "What we do" : "Our Team"}
</motion.h1>

      <motion.div className="mountain"  style={{ y: yBg }}> </motion.div>
      <motion.div className="stars" style={{ x: yBg }}></motion.div>
      <motion.div className="planets" style={{ x: yBgslow }}></motion.div>
      
    </div>
  );
};

export default Parallax;
